var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CatalogosBannersInApp"}},[_c('navegacion',{staticClass:"mb-4"}),_c('banners-quicktable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }